import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';
import { StatCard } from '../shared';

const IntegrationStats = ({ connected, available, total, lastSync }) => {
  return (
    <Grid2 container spacing={2} sx={{ mb: 3 }}>
      <Grid2 xs={12} sm={6} md={3}>
        <StatCard label="Connected" value={connected} color="success.main" />
      </Grid2>
      <Grid2 xs={12} sm={6} md={3}>
        <StatCard label="Available" value={available} color="info.main" />
      </Grid2>
      <Grid2 xs={12} sm={6} md={3}>
        <StatCard label="Total" value={total} color="primary.main" />
      </Grid2>
      <Grid2 xs={12} sm={6} md={3}>
        <StatCard label="Last Sync" value={lastSync || 'Never'} color="text.primary" />
      </Grid2>
    </Grid2>
  );
};

export default IntegrationStats;
